module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-summer-1300.b119f6ef.svg";